import { ReportCardDesigner } from './report-cards/ReportCardDesigner';
import { useIsAdmin, useHasPermission } from '../lib/auth';
import { Navigate } from 'react-router-dom';

export function ReportCards() {
  const isAdmin = useIsAdmin();
  const canViewReportCards = useHasPermission('view_report_cards');
  
  // Si el usuario no tiene permiso para ver boletines, redirigir al dashboard
  if (!isAdmin && !canViewReportCards) {
    return <Navigate to="/" replace />;
  }
  
  return (
    <div>
      {isAdmin ? (
        <ReportCardDesigner />
      ) : (
        <div className="py-6 px-4 text-center">
          <div className="py-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Visualización de Boletines
            </h2>
            <p className="text-gray-600 mb-8">
              Como profesor, puedes ver los boletines de tus estudiantes pero no puedes modificar las plantillas.
            </p>
            <p className="text-gray-600">
              Para ver los boletines de tus estudiantes, ve a la sección "Introducción de Notas" y selecciona un estudiante.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}